import { RoofTile } from './rooftile';
import { TileFamily, TileFinish, TileColor, RoofArticle, Material, Underlagstak, MarketStr } from '@/calculation/common';
import { ExtraAssortment, AccessoryColor } from '@/enums';
import { replaceByArtnr } from '@/helpers/tile';

import { i18n } from '@/i18n';
const { t } = i18n.global;

export class Mecklenburger extends RoofTile {
  public constructor() {
    super(TileFamily.Mecklenburger, 330, 240);
    this.label = 'Mecklenburger 2-kupig';
    this.key = 'mecklenburger';
    this.material = Material.Betong;
    this.läktavstånd = {
      [MarketStr.Sverige]: {
        min: 310,
        angle14to18: 320,
        angle18to22: 340,
        angle22to80: 375,
      },
      [MarketStr.Norge]: {
        min: 310,
        angle14to18: 320,
        angle18to22: 340,
        angle22to80: 375,
      },
      [MarketStr.Tyskland]: {
        min: 315,
        angle14to18: 320,
        angle18to22: 340,
        angle22to80: 345,
      },
      [MarketStr.Finland]: {
        min: 310,
        angle14to18: 320,
        angle18to22: 340,
        angle22to80: 375,
      },
    };
    this.avstTillFörstaLäkt = {
      [MarketStr.Sverige]: 340,
      [MarketStr.Norge]: 370,
      [MarketStr.Tyskland]: 345,
      [MarketStr.Finland]: 340,
    };

    this.itemNos = {
      [RoofArticle.TakPanna]: 'M20024',
      [RoofArticle.NockPanna]: '030024',
      [RoofArticle.NockPannaAlt]: '033024',
      [RoofArticle.NockBörjan]: '031524',
      [RoofArticle.NockSlut]: '031624',
      [RoofArticle.BörjanValm]: '031024',
      [RoofArticle.BörjanValmAlt]: '031824',
      [RoofArticle.NockBörjanAlt]: '031824',
      [RoofArticle.NockSlutAlt]: '032024',
      [RoofArticle.NockTBörjan]: '036024',
      [RoofArticle.NockTSlut]: '036124',
      [RoofArticle.NockTBörjanAlt]: '036324',
      [RoofArticle.ValmKlocka]: '035024',
      /* not verified */ [RoofArticle.ValmKlockaBörjan]: '035224',
      /* not verified */ [RoofArticle.ValmKlockaSlut]: '035324',
      [RoofArticle.NockXLutande]: '037024',
      /* not verified */ [RoofArticle.NockXLutandeAlt]: '037424',
      /* not verified */ [RoofArticle.NockXPlan]: '037124',
      [RoofArticle.HalvPanna]: 'M21024',
      [RoofArticle.GavelPannaVänster]: 'M41124',
      [RoofArticle.GavelPannaHöger]: 'M41024',
      [RoofArticle.GavelPannaVänsterBred]: 'M40124',
      [RoofArticle.GavelPannaHögerBred]: 'M40024',
      [RoofArticle.GavelBeslag]: '041624',
      [RoofArticle.DubbelvingadPanna]: 'M21524',
      /* not verified */ [RoofArticle.MansardPanna]: 'M23024',
      [RoofArticle.PultPanna]: 'M41824',
      [RoofArticle.PultPannaGavelVänster]: 'M42124',
      [RoofArticle.PultPannaGavelHöger]: 'M42024',
      /* not verified */ [RoofArticle.Ventilationshuv]: '052224',
      /* not verified */ [RoofArticle.Ventilationshuv2]: '088524',
      /* not verified */ [RoofArticle.VentilationshuvMontering]: '060200',
      [RoofArticle.Avluftare]: 'M50124',
      /* not verified */ [RoofArticle.Avluftare2]: '050724',
      /* not verified */ [RoofArticle.AvluftarePlåt]: '051220',
      /* not verified */ [RoofArticle.AvluftarePlåtMontering]: '060100',
      [RoofArticle.Kragrör]: '061220',
      /* not verified */ [RoofArticle.Rififi]: '060000',
      /* not verified */ [RoofArticle.InfästTaksteg]: '081190',
      /* not verified */ [RoofArticle.Taksteg]: '083324',
      /* not verified */ // [RoofArticle.Glidskydd]: '072920',
      /* not verified */ [RoofArticle.Snöglidhinder]: '081720',
      /* not verified */ [RoofArticle.SnöglidhinderKonsol]: '081920',
      [RoofArticle.Valmtätning300]: '092420',
      [RoofArticle.Valmtätning340]: '090520',
      [RoofArticle.Valmtätning370]: '090720',
      [RoofArticle.Valmtätning5m300]: '090320',
      [RoofArticle.Valmtätning5m370]: '090620',
      /* not verified */ [RoofArticle.Ventinock]: '090224',
      [RoofArticle.LuftningsPanna]: 'M56024',
      /* not verified */ [RoofArticle.Rändalstätning]: '118520',
      /* not verified */ [RoofArticle.Fågelband]: '092020',
      /* not verified */ [RoofArticle.Fågelband5mSvart]: '092120',
      /* not verified */ [RoofArticle.Fågelband5mRöd]: '092124',
      /* not verified */ [RoofArticle.VentiFågelband]: '091520',
      /* not verified */ [RoofArticle.Takluftare]: '097200',
      /* not verified */ [RoofArticle.Nocktätningsremsa]: '093110',
      /* not verified */ [RoofArticle.SpikPanna]: '094291',
      /* not verified */ [RoofArticle.SkruvPanna]: '094491',
      /* not verified */ [RoofArticle.Stormclips]: '096290',
      /* not verified */ // [RoofArticle.Stormclips2]: '096491',
      /* not verified */ [RoofArticle.EasyClip]: '096591',
      /* not verified */ [RoofArticle.EasyClip45x70]: '067091',
      /* not verified */ [RoofArticle.EasyClip30x48]: '067591',
      /* not verified */ [RoofArticle.EasyClip36x48]: '068091',
      [RoofArticle.Nockskruv]: '094391',
      [RoofArticle.NockskruvAlt]: '093691',
      /* not verified */ [RoofArticle.Nockklammer]: '114724',
      /* not verified */ [RoofArticle.Nockbrädshållare]: '065190',

      /* not verified */ // Roof Security
      /* not verified */ [RoofArticle.Bärläktsteg45]: '076220',
      /* not verified */ [RoofArticle.Bärläktsteg25]: '076220',
      /* not verified */ [RoofArticle.KoppladeTaksteg]: '084320',
      /* not verified */ [RoofArticle.InfästningKoppladeTaksteg]: '083990',
      /* not verified */ [RoofArticle.Glidskydd]: '072920',
      /* not verified */ [RoofArticle.Taklucka]: '190120',
      /* not verified */ [RoofArticle.Säkerhetskrok]: '070120',
      /* not verified */ [RoofArticle.Snökrok]: '081420',
      /* not verified */ [RoofArticle.Fästögla]: '171690',
      /* not verified */ [RoofArticle.SpårPanna]: '073624',
      /* not verified */ [RoofArticle.SnowSlideObstacle]: '081790',
      /* not verified */ [RoofArticle.SnowSlideObstacleKonsol]: '081990',
      /* not verified */ [RoofArticle.IsStoppare]: '083020',

      /* not verified */ [RoofArticle.BTSUnderlagstak]: '128001',
    };

    this.marketSpecificItemNos = {
      [MarketStr.Norge]: {
        [RoofArticle.Kragrör]: '061220',
        [RoofArticle.Ventilationshuv]: '088524',
        [RoofArticle.Valmtätning300]: '092420',
      },
      [MarketStr.Tyskland]: {
        [RoofArticle.BörjanValm]: '031124',

        [RoofArticle.AvluftareTyskSpitze]: '061224',
        [RoofArticle.LösVenthattSpitze]: '050824',
        [RoofArticle.Dunstrohrlufter100110]: 'M87824',
        [RoofArticle.Entwässerunglü100110]: 'M85124',
        [RoofArticle.Dunstrohrlufter125]: 'M88324',
        [RoofArticle.Entwässerunglü125]: 'M85224',
        [RoofArticle.Dunstrohrlufter160]: 'M85524',
        [RoofArticle.FlexrörAvluftare10070]: '110600',
        [RoofArticle.FlexrörAvluftare12570]: '110640',

	[RoofArticle.Tätningsbeslag]: '095520',
	[RoofArticle.RidgePlate]: '118020',
	[RoofArticle.RidgePlateMount]: '118120',
	[RoofArticle.ChimneySealant5m]: '115720',
	[RoofArticle.ChimneySealant7m]: '115820',
	[RoofArticle.ChimneySealant8m]: '115920',
	[RoofArticle.RidgeSealant]: '118520',
	[RoofArticle.VentivalmPlast]: '091420',
	[RoofArticle.VentivalmBorst]: '091120',
	[RoofArticle.Fågelband]: '092020',
	[RoofArticle.VentiFågelband]: '091520',

        [RoofArticle.GastDurchgGS]: 'M88724',
        [RoofArticle.AntennenDurchgPanna]: 'M88924',
        [RoofArticle.AntennenAufsatz]: 'M85024',
        [RoofArticle.SolardurchgangspfanneTT]: 'M84824',
        [RoofArticle.SolardurchgangspfannePV]: 'M84724',
        [RoofArticle.Solarträgerhalter]: 'M89824',

	[RoofArticle.Sturmklammer456VA30x50Palema]: '113391',
	[RoofArticle.Sturmklammer456Zial30x50Palema]: '113390',
	[RoofArticle.Sturmklammer456VA40x60Palema]: '113491',
	[RoofArticle.Sturmklammer456Zial40x60Palema]: '113490',
	[RoofArticle.SturmklammerNordmark2Zial]: '114291',
	[RoofArticle.Sturmklammer456VA30x50Mecklenburger]: '112291',
	[RoofArticle.Sturmklammer456Zial30x50Mecklenburger]: '112290',
	[RoofArticle.Sturmklammer456VA40x60Mecklenburger]: '112491',
	[RoofArticle.Sturmklammer456Zial40x60Mecklenburger]: '112490',
	[RoofArticle.SturmklammerExklusivZial]: '113691',
	[RoofArticle.SturmklammerCarismaZial]: 'C98191',

	[RoofArticle.RänndalsOValmklipps]: '096390',

        [RoofArticle.Nockklammer]: '114424',
        [RoofArticle.NockklammerAlt]: '113524',
        [RoofArticle.SkruvTillBetongtillbehör]: '095990',
        [RoofArticle.SkruvTillBetongtillbehörRostfri]: 'C98291',
      },
    };
  }

  public isSelectable(
    lAvstånd?: number | null,
    taklutning?: { min: number; max: number } | null,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    underlagstak?: Underlagstak | null,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    market?: MarketStr | null,
  ): { valid: boolean; message: string } {
    if (![MarketStr.Tyskland, MarketStr.Finland].includes(market || MarketStr.None)) return { valid: false, message: t('validation.notice.disabled_due_to_market') };
    // 310 <= Läktavstånd <= 375
    if (lAvstånd && (lAvstånd < 310 || lAvstånd > 375)) return { valid: false, message: t('validation.notice.disabled_due_to_lakt') };
    if (taklutning && (!this.angleInRange(taklutning.min, { min: 14, max: 80 }) || !this.angleInRange(taklutning.max, { min: 14, max: 80 })))
      return { valid: false, message: t('validation.notice.disabled_due_to_angle') };

    return { valid: true, message: '' };
  }

  public bärläktAvståndNock(angle: number): number {
    const ang = Number(angle.toFixed(1));
    if (ang >= 14 && ang <= 27) return 40;
    if (ang >= 27.1 && ang <= 35) return 25;
    if (ang >= 35.1 && ang <= 80) return 15;
    return 40;
  }

  public getAccessoryOptions(
    assortment: ExtraAssortment,
    market: MarketStr,
    { color, finish, accessoryColor }: { color: TileColor; finish: TileFinish; accessoryColor: AccessoryColor },
  ): string[] {
    const items: string[] = [];
    switch (assortment) {
      case ExtraAssortment.TakpannorOchTillbehor:
        if (market == MarketStr.Tyskland) {
          items.push(...[
            this.getTileVariant(RoofArticle.HalvPanna, { color, finish }),
            this.getTileVariant(RoofArticle.LuftningsPanna, { color, finish }),
          ].filter(art => typeof art === 'string') as string[]);
        }
        break;
      case ExtraAssortment.VentilationGenomforing: {
        if (market !== MarketStr.Tyskland) {
          const avluftare = this.getAccessoryVariant(RoofArticle.Avluftare, { color, finish, accessoryColor })?.artnr;
          if (avluftare) items.push(avluftare);
        }

        if (market == MarketStr.Tyskland) {
          // BENT-269: Ersättning för steg 3 "Avloppsluftare och Ventilationshuv" i KRI, flytta artiklarna till steg 5
          // Extra articles that depend on color
          for (const ra of [
              RoofArticle.Dunstrohrlufter100110,
              RoofArticle.Entwässerunglü100110, RoofArticle.Dunstrohrlufter125,
              RoofArticle.Entwässerunglü125, RoofArticle.Dunstrohrlufter160,

              RoofArticle.GastDurchgGS, RoofArticle.AntennenDurchgPanna, RoofArticle.AntennenAufsatz,
          ]) {
            const art = this.getAccessoryVariant(ra, { color, finish, accessoryColor, useFallbackTileColors: true })?.artnr;
            if (art) items.push(art);
          }

          items.push(...[this.getTileVariantByArtNr('M50924', { color, finish })].filter(Boolean) as string[]);

          // Extra articles that have static artnos
          for (const ra of [RoofArticle.FlexrörAvluftare10070, RoofArticle.FlexrörAvluftare12570]) {
            const art = this.getArticle(ra);
            if (art) items.push(art);
          }
        }
        break;
      }
      case ExtraAssortment.TatningLuftning:
        switch (accessoryColor) {
          case AccessoryColor.GalvanizedGreySilver:
          case AccessoryColor.Black:
            items.push(...['118620']);
            break;
          case AccessoryColor.BrickRed:
            items.push(...['118624']);
            break;
        }
        break;
      case ExtraAssortment.Solar:
        for (const ra of [RoofArticle.Solarträgerhalter, RoofArticle.SolardurchgangspfanneTT, RoofArticle.SolardurchgangspfannePV]) {
          const art = this.getAccessoryVariant(ra, { color, finish, accessoryColor, useFallbackTileColors: true })?.artnr;
          if (art) items.push(art);
        }

        // // "Also suitable for these models" articles
        // switch (this.getTileVariant(RoofArticle.TakPanna, { color, finish })) {
        //   case 'M20080': items.push('M84820', 'M84720'); break;
        //   case 'M20086': items.push('M84826', 'M84726'); break;
        // }
        break;
    }

    // Replace artnr if necessary
    for (let i = 0; i < items.length; i++) {
      items[i] = replaceByArtnr(items[i]);
    }

    return items;
  }
}
